var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCirclePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5006,
    r: 20,
    fill: "#774EFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2304_820",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4167 15.9173C15.4167 13.3507 17.4333 11.334 20 11.334C22.5667 11.334 24.5833 13.3507 24.5833 15.9173C24.5833 18.484 22.5667 20.5007 20 20.5007C17.4333 20.5007 15.4167 18.484 15.4167 15.9173ZM28.25 26.9173V28.7507C28.25 29.3007 27.8833 29.6673 27.3333 29.6673C26.7833 29.6673 26.4167 29.3007 26.4167 28.7507V26.9173C26.4167 25.359 25.225 24.1673 23.6667 24.1673H16.3333C14.775 24.1673 13.5833 25.359 13.5833 26.9173V28.7507C13.5833 29.3007 13.2167 29.6673 12.6667 29.6673C12.1167 29.6673 11.75 29.3007 11.75 28.7507V26.9173C11.75 24.3507 13.7667 22.334 16.3333 22.334H23.6667C26.2333 22.334 28.25 24.3507 28.25 26.9173ZM20 18.6673C18.4417 18.6673 17.25 17.4757 17.25 15.9173C17.25 14.359 18.4417 13.1673 20 13.1673C21.5583 13.1673 22.75 14.359 22.75 15.9173C22.75 17.4757 21.5583 18.6673 20 18.6673Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2304_820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9.50061,
    width: 22,
    height: 22,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCirclePrimary);
export default __webpack_public_path__ + "static/media/profile_circle_primary.92cc2d1913928f7766e6381284b490ff.svg";
export { ForwardRef as ReactComponent };